import { createModelSchema, primitive, object } from 'serializr';

import { Vehicle } from '@vromo/models';
import { DispatchAudit } from '@vromo/models';

export const DISPATCHED = 'dispatched';
export const UNDERWAY = 'underway';
export const RETURNED = 'returned';
export const CLOSED = 'closed';
export const FAILED = 'failed';

export type DispatchStatus =
    | typeof DISPATCHED
    | typeof UNDERWAY
    | typeof RETURNED
    | typeof CLOSED
    | typeof FAILED;

export class Dispatch {
    id?: number;
    created?: number;

    type?: DispatchStatus;
    vehicle?: Partial<Vehicle>;

    audit?: DispatchAudit;
}

createModelSchema(Dispatch, {
    id: primitive(),
    created: primitive(),
    type: primitive(),
    vehicle: object(Vehicle),
    audit: object(DispatchAudit)
});
